enum InspectionStandardTypes {
    Free = 'free',
    Nen2767 = 'nen2767',
    Eemua159 = 'eemua159',
    Api653 = 'api653',
    Api570 = 'api570',
    Fmeca = 'fmeca',
    Memo = 'memo',
    Model3d = 'model3d',
}

export { InspectionStandardTypes };
